<template>
         <basic-container id="month20210428">
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   ref="crud"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
             
                  >
                   <template slot="projectIdSearch">
                        <el-select v-model="searchForm.projectId" placeholder="请选择">
                                <el-option
                                v-for="item in projectList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                        </el-select>
                </template>
                <template slot="deptIdSearch">
                                <el-input 
                                        v-model="searchForm.deptName" 
                                        maxlength="50"
                                        show-word-limit
                                        placeholder="请输入科室"
                                ></el-input>
                                <!-- <avue-input-tree  
                                v-model="searchForm.deptId" 
                                :props='{ label: "title", value: "id" }'
                                placeholder="请选择" 
                                type="tree" :dic="deptList"></avue-input-tree> -->
                        
                </template>
                 <template slot="statisticsTimeSearch">
                               <el-date-picker
                                v-model="searchForm.statisticsTime"
                                type="month"
                                :clearable="false"
                                placeholder="选择月">
                                </el-date-picker>
                        
                </template>
                <template slot="meterTypeSearch">
                               <el-select v-model="searchForm.meterType" placeholder="请选择">
                                        <el-option
                                        v-for="item in meterTypeList"
                                        :key="item.id"
                                        :label="item.dictValue"
                                        :value="item.dictKey">
                                        </el-option>
                                </el-select>
                        
                </template>
                  <template slot="sum" slot-scope="scope">
                          <div v-if="
                          Number(scope.row.sum)>Number(scope.row.costTarget)
                          &&  scope.row.costTarget!=null 
                          " class="sumStyle" >
                                  {{scope.row.sum}}
                          </div>
                          <div v-if="
                          Number(scope.row.costTarget)>=Number(scope.row.sum) 
                          && Number(scope.row.sum)>=Number(scope.row.costTarget)*0.8
                          &&  scope.row.costTarget!=null 
                          " class="sumStyle2">
                                  {{scope.row.sum}}
                          </div>
                          <div v-if="
                          Number(scope.row.sum)<Number(scope.row.costTarget)*0.8
                          || scope.row.costTarget == null 
                          " style="sumStyle3">
                                  {{scope.row.sum}}
                          </div>
                  </template>
        </avue-crud>
    </basic-container>
</template>
<style lang="scss">
#month20210428 .sumStyle{
           min-width:80px;
           min-height:40;
           line-height:40px;
           text-align:center;
           background-color:#D9001B;
           color:#fff;
           margin-left: -10px;
        }
#month20210428 .sumStyle2{
           min-width:80px;
           min-height:40;
           line-height:40px;
           text-align:center;
           background-color:#FFFF00;
           color:#000;
           margin-left: -10px;
        }
#month20210428 .sumStyle3{
           min-width:80px;
           min-height:40;
           line-height:40px;
           text-align:center;
           margin-left: -10px;
        //    background-color:#f00;
        //    color:#000;
        }   
#month20210428 .el-table .cell, .el-table th>.cell{
        
}
</style>
<script>
import {
       getProjectList,//项目
       getDictData,//字典
       treeByIds,
       monthPage,
       monthSum,
    
}from "@/api/crmedical/energy/report/index.js"
export default {
        data(){
                return{
                        page: {
                                pageSize: 10,
                                currentPage: 1,
                                total: 0
                        },
                        searchForm:{
                                meterType:'',
                                projectId:'',
                                statisticsTime:'',
                                deptName:''
                        },
                        data:[],

                        projectList:[],//项目名称
                        deptList:[],//科室
                        meterTypeList:[],//仪表类型
                        option:{
                                height: 'auto',
                                calcHeight: 30,
                                menu: false,
                                addBtn: false,
                                editBtn: false,
                                viewBtn: false,
                                delBtn: false,
                                saveBtn: false,
                                emptyBtnText:'重置',
                                searchMenuSpan: 4,
                                indexLabel: '序号',
                                textAlign:'center',
                                headerAlign: 'center',
                                align: 'center',
                                border: true,
                                index: true,
                                selection: false,
                                column: [
                                        {
                                                label: "项目名称",
                                                prop: "projectId",
                                                search: true,
                                                searchslot:true,
                                                searchSpan:5,
                                                hide:true,
                                                type:'select',
                                                // searchslot:true,
                                                dataType: 'string',
                                                dicData:[],
                                                props:{
                                                        label:'name',
                                                        value:'id'
                                                },
                                                value:'',
                                                rules: [{
                                                        required: true,
                                                        message: "请选择项目",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: '部门',
                                                prop: 'deptId',
                                                searchSpan:5,
                                                searchslot:true,
                                                hide:true,
                                                type: 'select',
                                                search: 'true',
                                                overHidden:true,
                                                dataType: 'string'
                                        },
                                        {
                                                label: '部门',
                                                prop: 'deptName',
                                               
                                                type: 'select',
                                                overHidden:true,
                                        },
                                        {
                                                label: '月份',
                                                prop: 'statisticsTime',
                                                searchSpan:5,
                                                searchslot:true,
                                                hide:true,
                                                type: 'month',
                                                search: 'true',
                                                dataType: 'string'
                                        },
                                        {
                                                label: '能耗类型',
                                                prop: 'meterType',
                                                hide:true,
                                                searchslot:true,
                                                searchSpan:5,
                                                type: 'select',
                                                search: 'true',
                                                dataType: 'string'
                                        },
                                        {
                                                label: '1',
                                                prop: 'one'
                                        },
                                        {
                                                label: '2',
                                                prop: 'two'
                                        },
                                        {
                                                label: '3',
                                                prop: 'three'
                                        },
                                        {
                                                label: '4',
                                                prop: 'four'
                                        },
                                        {
                                                label: '5',
                                                prop: 'five'
                                        },
                                        {
                                                label: '6',
                                                prop: 'six'
                                        },
                                        {
                                                label: '7',
                                                prop: 'seven'
                                        },
                                        {
                                                label: '8',
                                                prop: 'eight'
                                        },
                                        {
                                                label: '9',
                                                prop: 'nine'
                                        },
                                        {
                                                label: '10',
                                                prop: 'ten'
                                        },
                                        {
                                                label: '11',
                                                prop: 'eleven'
                                        },
                                        {
                                                label: '12',
                                                prop: 'twelve'
                                        },
                                        {
                                                label: '13',
                                                prop: 'thirteen'
                                        },
                                        {
                                                label: '14',
                                                prop: 'fourteen'
                                        },
                                        {
                                                label: '15',
                                                prop: 'fifteen'
                                        },
                                        {
                                                label: '16',
                                                prop: 'sixteen'
                                        },
                                        {
                                                label: '17',
                                                prop: 'seventeen'
                                        },
                                        {
                                                label: '18',
                                                prop: 'eighteen'
                                        },
                                        {
                                                label: '19',
                                                prop: 'nineteen'
                                        },
                                        {
                                                label: '20',
                                                prop: 'twenty'
                                        },
                                        {
                                                label: '21',
                                                prop: 'twentyOne'
                                        },
                                        {
                                                label: '22',
                                                prop: 'twentyTwo'
                                        },
                                        {
                                                label: '23',
                                                prop: 'twentyThree'
                                        },
                                        {
                                                label: '24',
                                                prop: 'twentyFour'
                                        },
                                        {
                                                label: '25',
                                                prop: 'twentyFive'
                                        },
                                        {
                                                label: '26',
                                                prop: 'twentySix'
                                        },
                                        {
                                                label: '27',
                                                prop: 'twentySeven'
                                        },
                                        {
                                                label: '28',
                                                prop: 'twentyEight'
                                        },
                                        {
                                                label: '29',
                                                prop: 'twentyNine'
                                        },
                                        {
                                                label: '30',
                                                prop: 'thirty'
                                        },
                                        {
                                                label: '31',
                                                prop: 'thirtyOne'
                                        },

                                        {
                                                label: '合计',
                                                prop: 'sum',
                                                slot:true,
                                        },
                                        {
                                                label: '指标',
                                                prop: 'costTarget'
                                        },

                                ],
                        }
                }
        },
        created(){
                this.initData();
        },
        methods:{
                //     初始化数据
                async initData(){
                        this.searchForm.statisticsTime = new Date();
                        // 获取项目列表
                        await getProjectList().then(res=>{
                                this.projectList = res.data;
                                this.searchForm.projectId = this.projectList[0]?this.projectList[0].id:'';
                            
                        })

                        //     获取字典
                        await getDictData({ code: "meter_type" }).then(res=>{
                                this.meterTypeList = res.data;
                                this.searchForm.meterType = this.meterTypeList[0].dictKey;
                    
                        })
                        this.onLoad();
                },
                // 重置
                searchReset() {
                        this.searchForm.projectId = this.projectList[0].id;
                        // this.searchForm.deptId = this.deptList[0].id;
                        this.searchForm.deptName = '';
                        this.searchForm.meterType = this.meterTypeList[0].dictKey;
                         this.searchForm.statisticsTime = new Date();
                        this.query = {};
                        this.$refs.crud.toggleSelection();
                        this.onLoad();
                },
                searchChange(params, done) {
                        this.query = params;
                        this.page.currentPage = 1;
                        this.onLoad();
                        done();
                },
                currentChange(currentPage) {
                        this.page.currentPage = currentPage;
                        this.onLoad();
                },
                sizeChange(pageSize) {
                        this.page.pageSize = pageSize;
                        this.onLoad();
                },
                
                async onLoad(page) {

                        page = page || this.page;
                     
                        this.loading = true;
                        this.$forceUpdate();
                        this.searchForm.statisticsTime = this.dayjs(this.searchForm.statisticsTime).format("YYYY-MM-01 00:00:00");
                        await monthPage(
                                Object.assign({current: page.currentPage, size: page.pageSize}, this.searchForm)
                        ).then(({data}) => {
                        this.page.total = data.total;
                        this.page.currentPage = data.current;
                        this.page.size = data.size;
                        let totalPage = 0;//最大页数
                        if(Number(this.page.total)%Number(this.page.size)==0){
                                totalPage = Number(this.page.total)/Number(this.page.size);
                        }else{
                                totalPage = parseInt(Number(this.page.total)/Number(this.page.size))+1;
                        }
                        
                        if(Number(this.page.currentPage)==totalPage){
                                monthSum(this.searchForm).then(res=>{
                                        res.data.deptName = "合计:";
                                        data.records.push(res.data);
                                        this.data = data.records;
                                        this.loading = false;
                                })
                        }else{
                                this.data = data.records;

                        }
                        this.loading = false;
                        }).catch(res=>{
                        this.loading = false;
                        this.$forceUpdate();
                                
                        })
                        
                        
                
                } 
        }
}
</script>
